import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function BenefitsSection() {
  const benefits = ['Menos hinchazón abdominal desde los primeros días', 'Energía más estable durante el día', 'Menos antojos por la tarde', 'Mejor descanso nocturno', 'Sensación de liviandad en el cuerpo'];
  return <section className="bg-gradient-hero py-12 md:py-16 px-4 md:px-8 relative overflow-hidden" style={{
    paddingTop: "0px"
  }} data-id="element-15" data-mp="3nnqanu3bxdkb">
      {/* Decorative Gold Blur */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 blur-3xl rounded-full pointer-events-none" data-id="element-16" data-mp="3drdjp3z65dt9" />

      <div className="max-w-[1400px] mx-auto relative z-10" data-id="element-17" data-mp="2ztoy1txa22n5">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-18" data-mp="34r8aqpebu7cz">
          {/* Left Column */}
          <div className="space-y-10" data-id="element-19" data-mp="y0qylf8zwbt8">
            {/* Mini testimonial card */}

            {/* Emotional closer */}
            
          </div>

          {/* Right Column */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="flex justify-center lg:justify-end" data-id="element-20" data-mp="2bdut2vqd4mda">
            <div className="relative w-full max-w-sm" data-id="element-21" data-mp="2g775m7hrp2po">
              <div className="rounded-2xl shadow-gold overflow-hidden border border-gold/20" data-id="element-22" data-mp="1sgbfdesymfkj">
                <img src="https://cdn.shopify.com/s/files/1/0730/1614/8145/files/cosmos-image-1775842875547_430x.webp?v=1780543656" alt="Protocolo H.E.R. — Mujer planificando su alimentación" className="w-full h-auto object-cover" data-id="element-23" data-mp="1oepzdkl4pl64" />
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}